import styled from "styled-components";

import { AboveTheFolderSectionFallback } from "../../organisms/AboveTheFolderSection/styles";

export const ProductPresentationTemplateContainer = styled.div`
  --topbar-app-height: 64px;
  --topbar-group-height: 45px;

  transition: all 0.2s ease-in-out;

  padding-bottom: 3rem;
  padding-left: 1rem;
  padding-right: 1rem;

  position: relative;

  margin: 0 auto;

  @media (min-width: 600px) {
    padding-bottom: 3rem;
    padding-left: 3rem;
    padding-right: 3rem;
  }

  @media (min-width: 980px) {
    padding-top: 3rem;
  }

  @media (min-width: 1600px) {
    padding-left: 0;
    padding-right: 0;
  }

  ${AboveTheFolderSectionFallback} {
    height: 31.25rem;

    @media (min-width: 980px) {
      height: 18.75rem;
      padding-left: 4rem;
      padding-right: 4rem;
    }
  }

  padding-top: var(--topbar-group-height);
  @media (min-width: 991px) {
    padding-top: calc(
      2rem + var(--topbar-app-height) + var(--topbar-group-height)
    );
  }

  @media (min-width: 1300px) {
    max-width: 1520px;
  }
`;

export const ProductSafeSectionContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;

  gap: 3rem;

  margin-top: 4.5rem;

  flex-direction: column;
  @media (min-width: 980px) {
    flex-direction: row;
  }
`;
